module.exports = __webpack_public_path__ + "img/fish-filet.2a8174a2.png";